var Handlebars = require("../../node_modules/.pnpm/handlebars@4.7.8/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<p>\n    <em>\n        "
    + alias2(lookupProperty(helpers,"t").call(alias1,"This message was hidden because you have muted the sender.",{"name":"t","hash":{},"data":data,"loc":{"start":{"line":3,"column":8},"end":{"line":3,"column":75}}}))
    + "\n        <a class=\"reveal_hidden_message\">"
    + alias2(lookupProperty(helpers,"t").call(alias1,"Click here to reveal.",{"name":"t","hash":{},"data":data,"loc":{"start":{"line":4,"column":41},"end":{"line":4,"column":71}}}))
    + "</a>\n    </em>\n</p>\n";
},"useData":true});